import React from 'react'
import styled from 'styled-components'
import { Box, BlockLink, Text } from 'pcln-design-system'
import { Cars, Discount, Email, Help, Verified } from 'pcln-icons'
import { ConditionalBlockLinkType, Tile } from './types'

const StyledBox = styled(Box)`
  text-align: center;
`

const ConditionalBlockLink = ({ children, href }: ConditionalBlockLinkType) =>
  href ? <BlockLink href={href}>{children}</BlockLink> : <>{children}</>

const ICONS: any = {
  Cars,
  Discount,
  Email,
  Help,
  Verified
}

const ReasonsToBelieveTile = ({
  headingFontColor,
  href = '',
  iconColor,
  subtextFontColor,
  tileContent,
  tileCount
}: Tile) => {
  const { heading, iconName, subtext } = tileContent
  const Icon = ICONS[iconName] || Box
  const paddingX = tileCount < 4 ? 4 : 2

  return (
    <StyledBox width={1 / tileCount} px={paddingX} py={3}>
      <ConditionalBlockLink href={href}>
        <Icon color={iconColor} size={28} />
        <Text
          caps
          color={headingFontColor}
          fontWeight="bold"
          textAlign="center"
          py={2}
        >
          {heading}
        </Text>
        <Text color={subtextFontColor} textAlign="center" fontSize={1}>
          {subtext}
        </Text>
      </ConditionalBlockLink>
    </StyledBox>
  )
}

export default ReasonsToBelieveTile
